import PassSessions from "./PassSessions";
import './passSessions.scss';

export default PassSessions;